import React from 'react'
import "./loader.css"

const Loader = () => {
  return (
    <div className='pre-loader'>
        <span class="loader"></span>
    </div>
  )
}

export default Loader